import {gql} from '@apollo/client';

export const sprintQueries = {
    ALL_SPRINTS_BY_BOARD_ID: gql`
        query AllSprintsByBoardId(
            $boardId: String!
            $search: String
            $after: String
            $first: Int
            $before: String
            $last: Int
        ) {
            allSprints(
                where: {board: {slug: {eq: $boardId}}}
                after: $after
                search: $search
                first: $first
                before: $before
                last: $last
                order: {startData: ASC}
            ) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    id
                    title
                    isPinned
                    startData
                    endData
                    boardId
                    isDefault
                    incompleteItemCount
                    sprintStatus
                    details
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    `,
};
